import { CustomVisitorEnum } from "../custom";
import { groupHighchartsOneMeasure as groupHighchartsOneMeasureFunc } from "./groupHighchartsOneMeasure";
import { kpi as kpiFunc } from "./kpi";
export var ComparisonVisitorEnum;
(function (ComparisonVisitorEnum) {
    ComparisonVisitorEnum["kpi"] = "kpi";
    ComparisonVisitorEnum["groupHighchartsOneMeasure"] = "groupHighchartsOneMeasure";
})(ComparisonVisitorEnum || (ComparisonVisitorEnum = {}));
export const CustomVisitorsComparisonVisitorsCompatibility = new Map([
    [ComparisonVisitorEnum.kpi, [CustomVisitorEnum.kpi]],
    [ComparisonVisitorEnum.groupHighchartsOneMeasure, [CustomVisitorEnum.highchartsOneMeasure]]
]);
export const ComparisonVisitors = {
    [ComparisonVisitorEnum.kpi]: {
        visitor: (args) => kpiFunc(args)
    },
    [ComparisonVisitorEnum.groupHighchartsOneMeasure]: {
        visitor: (args) => groupHighchartsOneMeasureFunc(args[0], args?.[1])
    }
};
